export default "__VITE_ASSET__CA5XSmSe__"